import React from 'react';
import _get from 'lodash/get';
import { v4 as uuidv4 } from 'uuid';
import { Option } from '@lib/interfaces/form';

export const getNewOptionValue = (position?: number) => {
  const option: Option = {
    id: `new-${uuidv4()}`,
    value: '',
    values: [''],
  };
  if (position !== undefined) {
    option.position = position;
  }
  return option;
};

export const onKeyDownFn = (
  e: React.KeyboardEvent<HTMLInputElement>,
  {
    onRemove,
    onAdd,
    index,
  }: {
    onRemove?: () => void;
    onAdd?: (value: Option, newIndex?: number) => void;
    index?: number;
  },
) => {
  const { key } = e;
  const value = _get(e, 'target.value', '') as string;
  if (key === 'Backspace' && value.length === 0 && onRemove) {
    e.preventDefault();
    onRemove();
  }
  if (key === 'Enter' && onAdd) {
    e.preventDefault();
    const nextIndex = index === undefined ? undefined : index + 1;
    onAdd(getNewOptionValue(), nextIndex);
  }
};
